/* All menu levels, bound and fallback. Native details remain available for touch/keyboard. */
(() => {
  const key = 'drmMenuHoverInstalled';
  if (window[key]) return;
  window[key] = true;
  const selector = 'details[data-drm-menu-branch]';
  const desktop = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
  document.addEventListener('pointerover', event => {
    if (!desktop.matches || event.pointerType === 'touch') return;
    let branch = event.target.closest?.(selector);
    while (branch) {
      const item = branch.parentElement;
      for (const sibling of item.parentElement.children) {
        if (sibling !== item) sibling.querySelectorAll(selector).forEach(node => { node.open = false; });
      }
      branch.open = true;
      branch = item.parentElement.closest(selector);
    }
  });
  document.addEventListener('pointerout', event => {
    if (!desktop.matches || event.pointerType === 'touch') return;
    let branch = event.target.closest?.(selector);
    while (branch) {
      if (event.relatedTarget instanceof Node && branch.contains(event.relatedTarget)) break;
      branch.querySelectorAll(selector).forEach(node => { node.open = false; });
      branch.open = false;
      branch = branch.parentElement.parentElement.closest(selector);
    }
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const branch = event.target.closest?.(selector);
    if (!branch) return;
    branch.querySelectorAll(selector).forEach(node => { node.open = false; });
    branch.open = false;
    branch.querySelector('summary')?.focus();
    event.preventDefault();
    event.stopPropagation();
  });
})();
